package org.example.zone360.pages.coachDetails.sessionAllDetails.summaryBox

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.launch
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.EditSummaryRequest
import org.example.zone360.models.GetSessionsData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.summaryAnalysis

@Composable
fun SummaryBox(
    sessionsData: GetSessionsData,
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    toastMessageCall: (String) -> Unit,
    disable: Boolean
) {
    val scope = rememberCoroutineScope()
    var summaryText by remember { mutableStateOf("") }


    var editSummary by remember { mutableStateOf(false) }
    var hideRefresh by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(sessionsData.sessionId) {
        summaryText = sessionsData.summary
        hideRefresh = sessionsData.summaryRevision > 2
    }
    if (editSummary) {
        EditSummary(
            initialSummary = summaryText,
            sessionData = sessionsData,
            onDialogDismiss = {
                editSummary = false
            },
            toastMessageCall = toastMessageCall,
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            onSummaryUpdated = { updatedSummary, updatedSessionJson ->
                summaryText = updatedSummary
                sessionsData.sessionData = updatedSessionJson
            },
            onSummaryEdit = {

            }
        )
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .maxHeight(400.px)
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
            .padding(16.px)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.1f)
            )
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            SectionTitle("Summary")

                Row(
                    modifier = Modifier.gap(6.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (!disable) {
                    if (!hideRefresh) {
                        if (isLoading) {
                            ProgressIndicator()
                        } else {
                            Image(src = Res.Images.sync_icon,
                                modifier = Modifier.size(18.px).cursor(Cursor.Pointer)
                                    .onClick {
                                        scope.launch {
                                            try {
                                                isLoading = true
                                                val request = EditSummaryRequest(
                                                    text = sessionsData.text,
                                                    repair_text_before_analysis = true,
                                                    session_type = sessionsData.sessionType,
                                                    coach_name = sessionsData.coachName,
                                                    player_name = sessionsData.playerName,
                                                    domain_type = sessionsData.domainType,
                                                    get_summary = true,
                                                    summary_only = true,
                                                    edit_only = false,
                                                    get_insights = false,
                                                    session_id = sessionsData.sessionId,
                                                    language = sessionsData.language,
                                                    organization = AppGlobal.userData.organization
                                                )
                                                val response = summaryAnalysis(request)
                                                summaryText = response.response.summary
                                                val update = response.response.summaryRevision
                                                if (update >= 2) {
                                                    hideRefresh = true
                                                }

                                            } catch (
                                                e: Exception
                                            ) {
                                                toastMessageCall("Failed: ${e.message}")
                                            } finally {
                                                isLoading = false
                                            }
                                        }
                                    })
                        }
                    }
                    Image(
                        src = Res.Images.gray_Pencil_Icon,
                        modifier = Modifier.cursor(Cursor.Pointer)
                            .onClick {
                                editSummary = true
                            }
                    )
                }
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .maxHeight(360.px)
                .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
        ) {
            val cleanedSummary = summaryText
                .trim()
                .lines()
                .filter { it.isNotBlank() }.joinToString("\n") { it.trim() }

            FieldTitleTextNormalSimple(
                width = 100.percent,
                whiteSpace = WhiteSpace.PreWrap,
                fontFamily = Constants.IBM_FONT,
                fontSize = 16.px,
                text = cleanedSummary.ifEmpty { "No summary available." }
            )

        }
    }
}
